import { render, staticRenderFns } from "./ComponentDetail.vue?vue&type=template&id=7171a832&"
import script from "./ComponentDetail.vue?vue&type=script&lang=ts&"
export * from "./ComponentDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports